import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  width: 100%;
  background-color: #ffffff;
  padding: 24px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 560px;
  text-align: center;
`;

export const Illustration = styled.img`
  width: 128px;
  height: 116px;
  margin-bottom: 24px;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  margin-top: 32px;
  flex-wrap: wrap;
  justify-content: center;
`;
